import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class ExternalLibsService extends RequestBase {
    BasePath = 'api/externallibs';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetProviders(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetProviders', this.options);
    }

    // Empty properties are left untouched by the server, so a single surface can be switched
    // without restating the others.
    SetProviders(data): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/SetProviders', data, this.options);
    }

    ResetProviders(): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/ResetProviders', {}, this.options);
    }
}
